import React, { useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'
import PropTypes from 'prop-types'

import { Select } from 'mailup-web-components'

import { searchState } from 'Pages/AbTestList/recoil/state/search'

import {
  ABTEST_LIST_TYPE_ALL,
  ABTEST_LIST_TYPE_AUTO,
  ABTEST_LIST_TYPE_MANUAL,
  ABTEST_LIST_TYPE_100
} from 'Constants'

export const InputType = ({ onChange }) => {
  const intl = useIntl()
  const search = useRecoilValue(searchState)

  const { filterType } = search

  const { current: options } = useRef([
    {
      label: intl.formatMessage({ id: 'Load.MailupCommon.All' }),
      value: ABTEST_LIST_TYPE_ALL
    },
    {
      label: intl.formatMessage({ id: 'Load.AbTest.TypeAuto' }),
      value: ABTEST_LIST_TYPE_AUTO
    },
    {
      label: intl.formatMessage({ id: 'Load.AbTest.TypeManual' }),
      value: ABTEST_LIST_TYPE_MANUAL
    },
    {
      label: intl.formatMessage({ id: 'Load.AbTest.Type100' }),
      value: ABTEST_LIST_TYPE_100
    }
  ])

  const handleChange = useRecoilCallback(({ set }) => value => {
    set(searchState, prev => {
      onChange(value)
      return {
        ...prev,
        filterType: value
      }
    })
  })

  return (
    <Select
      searchable={false}
      options={options}
      onChange={handleChange}
      value={filterType}
    />
  )
}

InputType.propTypes = {
  onChange: PropTypes.func
}
